import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  useColorModeValue,
  useColorMode,
  Skeleton, 
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import axios from "axios";
import apiUrl from "../../../variables/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import darkStyles from "variables/darkStyles";

const initialValues = {
  fault: "",
  faultedItem: "",
  faultType: "",
  faultDescription: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "To pole jest obowiazkowe";
    }
  });

  return errors;
};

function Page() {
  const [formData, setFormData] = useState(initialValues);

  const [vehicles, setVehicles] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/vehicles", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        const vehicles = response.data;
        const formattedData = vehicles.reduce((acc, item) => {
          const existingUnit = acc.find((unit) => unit.unit === item.unit);
          if (existingUnit) {
            existingUnit.vehicles.push(item.operationalNumber);
          } else {
            acc.push({ unit: item.unit, vehicles: [item.operationalNumber] });
          }
          return acc;
        }, []);
        const formattedOptions = formattedData.map((unit) => ({
          label: unit.unit,
          options: [
            { label: "Budynek " + unit.unit, value: "Budynek " + unit.unit },
            ...unit.vehicles.map((vehicle) => ({
              label: vehicle,
              value: vehicle,
            })),
          ],
        }));
        setVehicles(formattedOptions);
        console.log(formattedData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const formikRef = React.useRef();
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);

    setFormData(values);
    axios
      .post(apiUrl + "/data/faultsDemands", values, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano usterkę/zapotrzebowanie");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error(
            "Napotkano błąd podczas wysyłania usterek/zapotrzebowania"
          );
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };
  const { colorMode } = useColorMode();

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={handleSubmit}
          innerRef={formikRef}
        >
          {({ isSubmitting, formik }) => (
            <Form>
              <SimpleGrid
                columns={{ sm: 1, md: 2, xl: 4 }}
                spacing="24px"
                mb="20px"
              >
                <Stack direction={"column"}>
                  <Field name="fault">
                    {({ field, form }) => (
                      <FormControl
                        id="fault"
                        isRequired
                        isInvalid={form.errors.fault && form.touched.fault}
                      >
                        <FormLabel>Co zgłaszasz?</FormLabel>
                        <RadioGroup name="fault" colorScheme="red">
                          <Stack direction="row">
                            <CustomCheckbox
                              key="Usterka"
                              label="Usterka"
                              isChecked={form.values.fault == "Usterka"}
                              onChange={() => {
                                form.setFieldValue(field.name, "Usterka");
                              }}
                            />
                            <CustomCheckbox
                              key="Zapotrzebowanie"
                              label="Zapotrzebowanie"
                              isChecked={form.values.fault == "Zapotrzebowanie"}
                              onChange={() => {
                                form.setFieldValue(
                                  field.name,
                                  "Zapotrzebowanie"
                                );
                              }}
                            />
                          </Stack>
                        </RadioGroup>
                        <FormErrorMessage>{form.errors.fault}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="faultedItem">
                    {({ field, form }) => (
                      <FormControl
                        id="faultedItem"
                        isRequired
                        isInvalid={
                          form.errors.faultedItem && form.touched.faultedItem
                        }
                      >
                        <FormLabel>Uszkodzony pojazd/budynek</FormLabel>
                          <ReactSelect
                            {...field}
                            noOptionsMessage={() => "Brak dostępnych opcji"}
                            options={vehicles}
                            isLoading={vehicles.length === 0}
                            placeholder="Wybierz..."
                            styles={darkStyles()}
                            value={form.values.faultedItem}
                            onChange={(selectedOptions) => {
                              form.setFieldValue(field.name, selectedOptions);
                            }}
                          />
                        <FormErrorMessage>
                          {form.errors.faultedItem}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </Stack>
                <Field name="faultType">
                  {({ field, form }) => (
                    <FormControl
                      id="faultType"
                      isRequired
                      isInvalid={
                        form.errors.faultType && form.touched.faultType
                      }
                    >
                      <FormLabel>
                        Czego dotyczy usterka/zapotrzebowanie
                      </FormLabel>
                      <RadioGroup name="faultType" colorScheme="red">
                        <Stack direction="column">
                          <CustomCheckbox
                            key="Wóz"
                            label="Wóz"
                            isChecked={form.values.faultType == "Wóz"}
                            onChange={() => {
                              form.setFieldValue(field.name, "Wóz");
                            }}
                          />
                          <CustomCheckbox
                            key="Sprzęt na wozie"
                            label="Sprzęt na wozie"
                            isChecked={
                              form.values.faultType == "Sprzęt na wozie"
                            }
                            onChange={() => {
                              form.setFieldValue(field.name, "Sprzęt na wozie");
                            }}
                          />
                          <CustomCheckbox
                            key="Części wozu"
                            label="Części wozu"
                            isChecked={form.values.faultType == "Części wozu"}
                            onChange={() => {
                              form.setFieldValue(field.name, "Części wozu");
                            }}
                          />
                          <CustomCheckbox
                            key="Wyposażenie budynku"
                            label="Wyposażenie budynku"
                            isChecked={
                              form.values.faultType == "Wyposażenie budynku"
                            }
                            onChange={() => {
                              form.setFieldValue(
                                field.name,
                                "Wyposażenie budynku"
                              );
                            }}
                          />
                        </Stack>
                      </RadioGroup>
                      <FormErrorMessage>
                        {form.errors.faultType}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="faultDescription">
                  {({ field, form }) => (
                    <FormControl
                      id="faultDescription"
                      isRequired
                      isInvalid={
                        form.errors.faultDescription &&
                        form.touched.faultDescription
                      }
                    >
                      <FormLabel>Opis</FormLabel>
                      <Textarea {...field} placeholder="Treść" maxH={"500px"} />
                      <FormErrorMessage>
                        {form.errors.faultDescription}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
